import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { FileSignature } from 'lucide-react';

// Firmas de políticas (SuperAdmin y Super Master). Solo el Super Master publica nuevas versiones.
export default function Policies() {
  const { user } = useAuth();
  const [p, setP] = useState(null);
  const [text, setText] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => { api.getPolicy().then((r) => { setP(r.data); setText(r.data.text); }); api.getPolicyAcceptances().then((r) => setRows(r.data)).catch(() => {}); };
  useEffect(() => { load(); }, []);
  const publish = async () => { try { const r = await api.updatePolicy(text); toast.success(`SalesPRO: Versión ${r.data.version} publicada. Todos los usuarios deberán aceptarla.`); load(); } catch (e) { toast.error(e.response?.data?.detail || 'Error'); } };
  return (
    <div className="space-y-4" data-testid="policies-page">
      <h1 className="font-heading text-3xl font-black text-[#022C22] flex items-center gap-2"><FileSignature /> Políticas y firmas</h1>
      {user?.role_id === 'master' && p && (
        <Card><CardContent className="p-4 space-y-2">
          <p className="text-sm font-semibold">Versión vigente: {p.version}</p>
          <Textarea rows={10} value={text} onChange={(e) => setText(e.target.value)} className="text-xs" data-testid="policy-editor" />
          <Button onClick={publish} disabled={text === p.text} data-testid="policy-publish">Publicar nueva versión (todos deben volver a firmar)</Button>
        </CardContent></Card>
      )}
      <Card><CardContent className="p-4 overflow-x-auto">
        <table className="w-full text-sm" data-testid="acceptances-table"><thead><tr className="text-left text-xs text-[#64748B] border-b"><th className="py-2">Fecha y hora</th><th>Usuario</th><th>Rol</th><th>Firma</th><th>Versión</th><th>IP</th><th /></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.acceptance_id} className="border-b border-[#F1F5F9]"><td className="py-2">{new Date(r.accepted_at).toLocaleString()}</td><td>{r.full_name}<span className="block text-[10px] text-[#94A3B8]">{r.email}</span></td><td>{r.role_id}</td><td className="italic">{r.signature_name}</td><td>v{r.policy_version}</td><td className="text-[10px]">{r.ip}</td>
              <td><button className="text-xs text-primary" onClick={() => setOpen(r)}>Ver texto</button></td></tr>))}</tbody></table>
        {rows.length === 0 && <p className="text-sm text-[#94A3B8] py-4 text-center">Sin firmas registradas.</p>}
      </CardContent></Card>
      {open && <div className="fixed inset-0 z-50 bg-black/50 grid place-items-center p-3" onClick={() => setOpen(null)}><pre className="bg-white rounded-lg p-4 max-w-2xl max-h-[80vh] overflow-y-auto text-xs whitespace-pre-wrap">{open.policy_text}</pre></div>}
    </div>
  );
}
